import React from "react";
import {
  SEO,
  Image,
  MarkdownContent,
  BasicCarousel,
} from "@bluefin/components";
import { Grid, Segment } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import {
  getComponentFiles,
  getComponentContentNodeContent,
} from "../utils/utils";
import "../style/legacy.css";

export default class LegacyPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          title={fishermanBusinessWebsitePage.seoTitle}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
          ogUrl={"https://www.salondrew.com/legacy/"}
        />
        <Grid
          className={"custom-page-our-legacy custom-page-grid"}
          style={{}}
          stackable={true}
        >
          <Grid.Row
            className={"iiljcgfhllahepii full-width"}
            style={{ padding: 16 }}
            textAlign={"center"}
            verticalAlign={"middle"}
            columns={1}
          >
            <Grid.Column
              className={"hhjlmklmafkjefha"}
              style={{ padding: 16 }}
              textAlign={"center"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <Image
                  className={"image-block"}
                  style={{ minHeight: "650px", backgroundSize: "cover" }}
                  src={getComponentFiles({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "Image",
                    componentIdentifier: "11b505be-6e25-4c08-b525-c1e502b92280",
                    numToSelect: 1,
                  })}
                  background={true}
                >
                  <MarkdownContent
                    className={"text-block"}
                    style={{
                      top: 0,
                      left: 0,
                      color: "#FFFFFF",
                      right: 0,
                      bottom: 0,
                      display: "flex",
                      padding: "16px",
                      position: "absolute",
                      overflowY: "scroll",
                      alignItems: "center",
                      background: "rgba(0,0,0,0.4)",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                    content={getComponentContentNodeContent({
                      components: fishermanBusinessWebsitePage.components,
                      componentName: "MarkdownContent",
                      componentId: "d76262ba-93e2-4978-a142-e2fb1e8da174",
                      defaultValue: "",
                    })}
                  />
                </Image>
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"abmgakokckjcekbk"}
            style={{ padding: "40px" }}
            textAlign={"center"}
            verticalAlign={"middle"}
          >
            <Grid.Column
              className={"bdahkcoiaehfemje"}
              style={{ padding: 16 }}
              width={6}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__b59f53c8-c01a-447d-8db5-fc5a1e8242e5"}
                >
                  <BasicCarousel
                    className={"about-section-image-carousel"}
                    size={1}
                    slide={true}
                    displayIndicators={false}
                    displayPlayPauseButton={true}
                    autoScroll={false}
                    leftArrowIcon={"arrow-left"}
                    rightArrowIcon={"arrow-right"}
                    mobile={{ size: 1 }}
                    items={[
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/Legacy_1.JPG"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/IMG_7479.JPG"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/IMG_7071_SezwJtq.jpg"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/IMG_7077.JPG"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/IMG_7069_Ih3NQRd.jpg"
                        }
                      />,
                    ]}
                  />
                </React.Fragment>
              </Segment>
            </Grid.Column>
            <Grid.Column
              className={"opfegocoacclelhl"}
              style={{ padding: 16 }}
              width={10}
              textAlign={"left"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "8ef3c5ed-d067-4677-b30c-4ee8ebbf8bff",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"fepnmcnghfhneooj"}
            style={{ padding: "40px", background: "#E6E1DC" }}
            textAlign={"center"}
            verticalAlign={"middle"}
            reversed={"mobile"}
          >
            <Grid.Column
              className={"bdfmjefmpapmeoda"}
              style={{ padding: 16 }}
              width={10}
              textAlign={"left"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "83631861-a74e-4942-aa6b-5bfdb6df8f46",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
            <Grid.Column
              className={"biainfpnpepjemgi"}
              style={{ padding: 16 }}
              width={6}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__9c0429c6-69c7-4d15-8b47-61cd1243e097"}
                >
                  <BasicCarousel
                    className={"about-section-image-carousel"}
                    size={1}
                    slide={true}
                    displayIndicators={false}
                    displayPlayPauseButton={true}
                    autoScroll={false}
                    leftArrowIcon={"arrow-left"}
                    rightArrowIcon={"arrow-right"}
                    mobile={{ size: 1 }}
                    items={[
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/Legacy_2.jpg"
                        }
                      />,
                      <Image
                        key={"2"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/Legacy_2b.JPG"
                        }
                      />,
                      <Image
                        key={"3"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/464213170_8943294709027639_3338444426195755847_n_oXPOFii.jpg"
                        }
                      />,
                      <Image
                        key={"4"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/464740361_8994218303935279_3562233303543948351_n.jpg"
                        }
                      />,
                      <Image
                        key={"5"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/464026301_8943276059029504_6839672513960517365_n_1.jpg"
                        }
                      />,
                      <Image
                        key={"6"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/464009965_8941401812550262_2103340149097025595_n.jpg"
                        }
                      />,
                      <Image
                        key={"7"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/464066116_8941401542550289_3902015313320248931_n_1.jpg"
                        }
                      />,
                      <Image
                        key={"8"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/463073961_8905707892786321_5915912829435596785_n_1.jpg"
                        }
                      />,
                      <Image
                        key={"9"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/462850527_8907900075900436_7785847929992577787_n_1.jpg"
                        }
                      />,
                    ]}
                  />
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"agajdnodadkpeppi"}
            style={{ padding: "40px" }}
            textAlign={"center"}
            verticalAlign={"middle"}
          >
            <Grid.Column
              className={"gflijhglklicehef"}
              style={{ padding: 16 }}
              width={6}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__49a9d45b-2e0b-4e60-8a47-0df59c2a1bab"}
                >
                  <BasicCarousel
                    className={"about-section-image-carousel"}
                    size={1}
                    slide={true}
                    displayIndicators={false}
                    displayPlayPauseButton={true}
                    autoScroll={false}
                    leftArrowIcon={"arrow-left"}
                    rightArrowIcon={"arrow-right"}
                    mobile={{ size: 1 }}
                    items={[
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/IMG_7860.jpg"
                        }
                      />,
                      <Image
                        key={"2"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/IMG_7862.jpg"
                        }
                      />,
                      <Image
                        key={"3"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/Grid3_1.jpg"
                        }
                      />,
                    ]}
                  />
                </React.Fragment>
              </Segment>
            </Grid.Column>
            <Grid.Column
              className={"ngokgmmbpadgemlp"}
              style={{ padding: 16 }}
              width={10}
              textAlign={"left"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "301c5d10-8527-46d8-a420-34d2f343f59b",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"bacobcjhcbgheoeo"}
            style={{ padding: "40px", background: "#E6E1DC" }}
            textAlign={"center"}
            verticalAlign={"middle"}
            reversed={"mobile"}
          >
            <Grid.Column
              className={"nbkhfdbfmnagemik"}
              style={{ padding: 16 }}
              width={10}
              textAlign={"left"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "dfca1993-599c-4236-93f2-b583ea442916",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
            <Grid.Column
              className={"ifkmmpldinkhejep"}
              style={{ padding: 16 }}
              width={6}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__4fc0108d-9984-4f25-83f5-bcf728dd09c7"}
                >
                  <BasicCarousel
                    className={"about-section-image-carousel"}
                    size={1}
                    slide={true}
                    displayIndicators={false}
                    displayPlayPauseButton={true}
                    autoScroll={false}
                    leftArrowIcon={"arrow-left"}
                    rightArrowIcon={"arrow-right"}
                    mobile={{ size: 1 }}
                    items={[
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/Legacy_4_.jpg"
                        }
                      />,
                      <Image
                        key={"2"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/IMG_7432.JPG"
                        }
                      />,
                      <Image
                        key={"3"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/IMG_7393.JPG"
                        }
                      />,
                      <Image
                        key={"4"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/512719317_24300381946220951_2508138692520552572_n.jpg"
                        }
                      />,
                      <Image
                        key={"5"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/IMG_7420.JPG"
                        }
                      />,
                      <Image
                        key={"6"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/dean_cards_FsmsILN.jpg"
                        }
                      />,
                      <Image
                        key={"7"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/513967778_24329825196609959_8474959298113776066_n.jpg"
                        }
                      />,
                      <Image
                        key={"8"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/464147210_8949850908372019_389067697110411093_n.jpg"
                        }
                      />,
                    ]}
                  />
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"apocahopkimpeogj"}
            style={{ padding: "40px" }}
            textAlign={"center"}
            verticalAlign={"middle"}
            reversed={""}
          >
            <Grid.Column
              className={"dnoijbibhedjemdc"}
              style={{ padding: 16 }}
              width={6}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__1963bb06-7941-4272-b3e9-01cfe9198348"}
                >
                  <BasicCarousel
                    className={"about-section-image-carousel"}
                    size={1}
                    slide={true}
                    displayIndicators={false}
                    displayPlayPauseButton={true}
                    autoScroll={false}
                    leftArrowIcon={"arrow-left"}
                    rightArrowIcon={"arrow-right"}
                    mobile={{ size: 1 }}
                    items={[
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/Legacy_7_.jpg"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/o-10_VmUz50X.jpg"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/IMG_7116.jpg"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/IMG_7128.jpg"
                        }
                      />,
                    ]}
                  />
                </React.Fragment>
              </Segment>
            </Grid.Column>
            <Grid.Column
              className={"iikddkggocahefei"}
              style={{ padding: 16 }}
              width={10}
              textAlign={"left"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "af174347-c2fd-41d0-9459-177cfa4aff37",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"jhlamjgcffjeepnp"}
            style={{ padding: "40px", background: "#E6E1DC" }}
            textAlign={"center"}
            verticalAlign={"middle"}
            reversed={"mobile"}
            columns={2}
          >
            <Grid.Column
              className={"ccblkogmfhjeenjm"}
              style={{ padding: 16 }}
              textAlign={"left"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "baad5e8d-eb5b-449d-bd36-c0d47c2f6218",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
            <Grid.Column className={"opcedcfoeejgempg"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__b7e4c1de-a152-4fb2-99c0-eaf33ce88028"}
                >
                  <BasicCarousel
                    className={"about-section-image-carousel"}
                    size={1}
                    slide={true}
                    displayIndicators={false}
                    displayPlayPauseButton={true}
                    autoScroll={false}
                    leftArrowIcon={"arrow-left"}
                    rightArrowIcon={"arrow-right"}
                    mobile={{ size: 1 }}
                    items={[
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/Legacy_6_duTMgun.jpg"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/DA_0039.jpg"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/DA_0026.jpg"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/DA_0037.jpg"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/IMG_7453.JPG"
                        }
                      />,
                    ]}
                  />
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"fpifapomipheecgf"}
            style={{ padding: "40px" }}
            textAlign={"center"}
            verticalAlign={"middle"}
            columns={2}
          >
            <Grid.Column className={"fejhemkcbgcpebcm"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__e3289d06-3588-419f-b246-b8816430b4a6"}
                >
                  <BasicCarousel
                    className={"about-section-image-carousel"}
                    size={1}
                    slide={true}
                    displayIndicators={false}
                    displayPlayPauseButton={true}
                    autoScroll={false}
                    leftArrowIcon={"arrow-left"}
                    rightArrowIcon={"arrow-right"}
                    mobile={{ size: 1 }}
                    items={[
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/Legacy_8_5reJbXv.jpg"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/SD_LBX_0070.jpg"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/FullSizeRender_bagi.jpg"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/SD_LBX_0079.jpg"
                        }
                      />,
                      <Image
                        key={"1"}
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/2f567991-302d-4241-99f1-c9cc816d6e4f/2023-01-04-6.jpg"
                        }
                      />,
                    ]}
                  />
                </React.Fragment>
              </Segment>
            </Grid.Column>
            <Grid.Column
              className={"jpeoppfffenheipe"}
              style={{ padding: 16 }}
              textAlign={"left"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "95c68007-4d81-4c6b-a1fd-752929689dc3",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"jkdcakccfndhenda"}
            style={{ padding: "40px", background: "#E6E1DC" }}
            textAlign={"center"}
            verticalAlign={"middle"}
            reversed={"mobile"}
            columns={2}
          >
            <Grid.Column
              className={"gmipibafcegiefbo"}
              style={{ padding: 16 }}
              textAlign={"left"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "3e13f5eb-27b3-4f23-9c4d-41e5e6fb7d47",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
            <Grid.Column className={"ibckeahdclfoefmm"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <Image
                  className={"image-block"}
                  style={{ minHeight: "240px", objectFit: "contain" }}
                  src={getComponentFiles({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "Image",
                    componentIdentifier: "ebcfcbe8-0692-4266-8b29-bb669e0424d0",
                    numToSelect: 1,
                  })}
                  background={false}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"indknfmbkjbkejop"}
            style={{ padding: "40px" }}
            textAlign={"center"}
            verticalAlign={"middle"}
          >
            <Grid.Column
              className={"jicjndfgnfcleecb"}
              style={{ padding: "30px", background: "#efdcd4" }}
              width={10}
              textAlign={"center"}
              verticalAlign={"middle"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "17ed8229-d396-4c55-ad56-338927876807",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"knigkbhlgkhjelpk full-width"}
            style={{ padding: "0px" }}
            columns={1}
          >
            <Grid.Column
              className={"nkfmimghkchgecng"}
              style={{ padding: "0px" }}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <Image
                  className={"image-block"}
                  style={{ maxHeight: "500px", minHeight: "500px" }}
                  src={getComponentFiles({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "Image",
                    componentIdentifier: "4691f21e-5440-43dc-a9a3-e4ffe5c7d1ee",
                    numToSelect: 1,
                  })}
                  background={true}
                >
                  <MarkdownContent
                    className={"text-block"}
                    style={{
                      top: 0,
                      left: 0,
                      color: "#FFFFFF",
                      right: 0,
                      bottom: 0,
                      display: "flex",
                      padding: "16px",
                      position: "absolute",
                      overflowY: "scroll",
                      alignItems: "center",
                      background: "rgba(0,0,0,0.62)",
                      flexDirection: "column",
                      justifyContent: "center",
                    }}
                    content={getComponentContentNodeContent({
                      components: fishermanBusinessWebsitePage.components,
                      componentName: "MarkdownContent",
                      componentId: "86469a86-3f80-4599-90f1-cde49f494dc6",
                      defaultValue: "",
                    })}
                  />
                </Image>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(_id: { eq: 35861 }) {
      title
      seoTitle
      description
      components {
        files {
          file
          altText
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
        order
        fastId
        componentIdentifier
        contentNodes {
          content
        }
      }
    }
  }
`;
